import { ADS_EVENT } from '../constants'
import { ADWORDS_DIDOMI_COOKIE } from '~~/modules/integrations/didomi/constants'

const adsService = {
  _adsEventsLoaded: false,
  queue: new Proxy([], {
    set: (target: any, property: any, value) => {
      target[property] = value
      setTimeout(() => {
        adsService._processQueue()
      }, 1)
      return true
    },
  }),
  _processQueue() {
    const { $didomiService } = useNuxtApp()
    if (
      import.meta.client &&
      $didomiService.hasConsent(ADWORDS_DIDOMI_COOKIE)
    ) {
      while (this.queue.length) {
        const ev = this.queue.shift()
        window.dataLayer.push(ev)
      }
    } else {
      console.log('ADS is not activated because Ads cookies are not allowed')
    }
  },
  send: (params: any) => {
    const ev = {
      event: ADS_EVENT,
      conversion_value: params.conversion_value,
      transaction_id: params.transaction_id,
      ...params.data,
    }
    adsService._loadAdsEvents()
    adsService.queue.push(ev)
  },
  _loadAdsEvents() {
    if (!import.meta.client || adsService._adsEventsLoaded) return
    window.didomiOnReady = window.didomiOnReady || []
    window.didomiOnReady.push(() => {
      adsService._processQueue()
      window.Didomi.on('consent.changed', () => {
        adsService._processQueue()
      })
    })
    adsService._adsEventsLoaded = true
  },
}

export default adsService
